import { CONFIG } from './config'

export const VALIDGUESSES = [
'abele',
'abéra',
'abile',
'abima',
'abita',
'abôna',
'abóou',
'abóra',
'abòra',
'abówa',
'abyéi',
'achon',
'achye',
'acoja',
'acoli',
'acóou',
'acrou',
'adjya',
'adjyo',
'âdjyó',
'adoba',
'adóra',
'adóta',
'adrwé',
'afana',
'afena',
'afére',
'afewa',
'afida',
'afówa',
'afron',
'afrou',
'agóta',
'akipa',
'akita',
'amina',
'amódó',
'amoja',
'amòra',
'andin',
'andzé',
'anese',
'angon',
'anjêe',
'anowa',
'anpwé',
'antan',
'antou',
'antse',
'aoule',
'apéja',
'apele',
'apeti',
'apéwa',
'apèwe',
'aplan',
'apléé',
'aplin',
'aplon',
'apréi',
'apwéé',
'arabe',
'arapa',
'arari',
'arche',
'aréna',
'aréta',
'arója',
'arówa',
'arpâé',
'arpyó',
'ârtse',
'artsé',
'aryin',
'aryon',
'aryou',
'aseou',
'aseta',
'aséta',
'astou',
'asyon',
'ataca',
'atèlè',
'ateni',
'atepi',
'atópa',
'atori',
'atóta',
'avâra',
'aveja',
'avowa',
'avwêe',
'avwéi',
'awéea',
'âwéta',
'bâcha',
'baché',
'bâché',
'bâcla',
'bacon',
'bafra',
'banca',
'bandi',
'banye',
'bârba',
'barbé',
'bârca',
'barma',
'bârma',
'batâa',
'batan',
'batéé',
'batin',
'bâton',
'batré',
'batse',
'bâtsó',
'bayâa',
'béchó',
'bechi',
'beeon',
'béida',
'béite',
'bèkye',
'belon',
'bemon',
'bënfé',
'berdé',
'bèrjé',
'berni',
'béton',
'betse',
'bewën',
'bibla',
'bidon',
'bièta',
'bijye',
'binda',
'blaga',
'blâga',
'blâma',
'bléca',
'bléta',
'blóca',
'bloji',
'bóche',
'bóché',
'bócla',
'bócon',
'bofon',
'bogan',
'bójae',
'bójéi',
'bókye',
'bòkye',
'bókyé',
'bonan',
'bonba',
'bónda',
'bonōo',
'bonta',
'bonye',
'bonyé',
'bòrda',
'bòrdé',
'bòrdó',
'borën',
'borgó',
'borla',
'bòrló',
'borne',
'bôrne',
'bosou',
'boton',
'bóton',
'bótsa',
'botse',
'botsé',
'bouja',
'bouló',
'bousa',
'bouwa',
'bowîa',
'brâja',
'braji',
'brasa',
'bravó',
'breca',
'bréca',
'briló',
'brisa',
'brivó',
'bróca',
'broné',
'bròon',
'brota',
'bróta',
'broun',
'bwata',
'bwati',
'bwita',
'bwite',
'bwóna',
'byowi',
'caâda',
'cabri',
'cacae',
'cacha',
'cadre',
'câdre',
'caeon',
'cafâa',
'caféi',
'cajën',
'câkyé',
'calon',
'candi',
'canéé',
'canon',
'canpa',
'canpó',
'canye',
'capon',
'carae',
'caréi',
'carié',
'carma',
'carmó',
'carné',
'caron',
'carpa',
'cârpé',
'cârta',
'carte',
'carti',
'catâa',
'catêe',
'catró',
'cátse',
'catsé',
'cavwa',
'cawën',
'chaba',
'chacó',
'chadó',
'chaea',
'chain',
'chapa',
'chápa',
'chara',
'châra',
'chata',
'châta',
'chate',
'chava',
'châva',
'chavó',
'chawa',
'chawe',
'chéae',
'checa',
'chela',
'chéna',
'chenó',
'chêra',
'chêre',
'cheto',
'chéwa',
'chiba',
'chitó',
'chiwa',
'chîwa',
'chobe',
'chócò',
'chóma',
'chóna',
'chónó',
'choōo',
'chóou',
'chopa',
'chópa',
'chópé',
'chópò',
'chóra',
'chóta',
'chóte',
'choun',
'chowe',
'chowa',
'chówa',
'chowé',
'chwin',
'chyin',
'clara',
'clian',
'clóca',
'clóou',
'clópa',
'clópé',
'close',
'clòte',
'cóbla',
'cócha',
'cochi',
'cócon',
'cojën',
'côlon',
'colôo',
'coman',
'coméi',
'cómin',
'conba',
'conta',
'contó',
'contò',
'cóóna',
'cópâe',
'copie',
'copié',
'coplé',
'copōo',
'córâe',
'côrba',
'cōrba',
'còrbé',
'còrbó',
'cōrda',
'cordi',
'corin',
'cōrna',
'còrné',
'corta',
'corti',
'corya',
'cóson',
'cotêe',
'cótéi',
'cotën',
'cóton',
'cótse',
'coudó',
'couse',
'cówâe',
'cowêe',
'cówéi',
'cowin',
'craea',
'cramò',
'crâné',
'crânó',
'crapa',
'crapó',
'crefa',
'crepi',
'crere',
'créta',
'creva',
'crîde',
'crója',
'crópa',
'cróta',
'crowi',
'crwéi',
'cwéna',
'cwete',
'cwife',
'cwire',
'cwite',
'dajon',
'dalōo',
'damou',
'danae',
'danse',
'danye',
'daoun',
'dapâa',
'davwé',
'debri',
'décló',
'deden',
'déean',
'dèjai',
'déjêe',
'dékye',
'demâa',
'déman',
'déméi',
'démon',
'demye',
'dëntò',
'déója',
'deoun',
'dépin',
'deplo',
'derâe',
'derdé',
'derën',
'dêrye',
'detri',
'detse',
'déwéi',
'dibló',
'dióra',
'ditéi',
'diton',
'dobën',
'dóbla',
'dobli',
'dóbló',
'dódze',
'dólon',
'donta',
'dorōo',
'dótâa',
'doura',
'douse',
'douwa',
'draga',
'dreti',
'drité',
'dróga',
'dromi',
'dzala',
'dzâna',
'dzâno',
'dzaou',
'dzapa',
'dzawa',
'dzefa',
'dzéró',
'dzeta',
'dzeti',
'dzoma',
'dzoné',
'dzora',
'dzóta',
'dzoué',
'dzoun',
'èbéne',
'echën',
'échôo',
'ecofi',
'écolè',
'ecore',
'écóta',
'écówa',
'écrou',
'éékye',
'ègawé',
'ègòta',
'éigro',
'éigró',
'éitró',
'éivwa',
'éivwe',
'èkyêe',
'élije',
'elite',
'èmapa',
'emena',
'ëncan',
'ëndri',
'ënfêe',
'ëngri',
'ënkye',
'enori',
'ënpli',
'ënréé',
'ënrwi',
'ënséi',
'ënsin',
'ëntin',
'ëntré',
'ënvai',
'ënvêe',
'èpana',
'épawa',
'epena',
'épéon',
'epeta',
'épóca',
'êrché',
'éréta',
'eriti',
'espêe',
'espie',
'éspré',
'espri',
'éstra',
'étapa',
'étawa',
'etiwa',
'étófa',
'étóna',
'étópa',
'étsêe',
'éwévé',
'ézósa',
'fache',
'fâche',
'faeâa',
'faéta',
'fanwé',
'fason',
'fâsōo',
'fatōo',
'favōo',
'favra',
'favre',
'féché',
'fédzó',
'fegyè',
'fejōo',
'féise',
'féita',
'fémâe',
'féméi',
'fèrma',
'fèrmó',
'fetou',
'fevri',
'fibló',
'fidéi',
'fideó',
'finta',
'firin',
'fivra',
'flama',
'flana',
'flapó',
'fléma',
'flócó',
'floné',
'flóré',
'flori',
'flota',
'flóta',
'fóbon',
'foche',
'fófré',
'folou',
'fomaé',
'foméi',
'fomōo',
'fonda',
'fonsa',
'fonta',
'forba',
'forbi',
'forda',
'fóréi',
'fôrje',
'fòrma',
'fôrna',
'forni',
'foryé',
'fótré',
'foura',
'fouró',
'fowia',
'fraca',
'frâné',
'frânó',
'frâre',
'frâte',
'fréja',
'frépa',
'frere',
'frija',
'friou',
'frite',
'fromi',
'fróta',
'fwata',
'fyèró',
'gâdzó',
'galâa',
'gamin',
'ganye',
'gaóna',
'gârbé',
'garda',
'garéé',
'garni',
'garse',
'gâtsó',
'gawan',
'gispi',
'gochó',
'goléi',
'gonsé',
'gorda',
'gordó',
'gótró',
'grâda',
'grané',
'grani',
'grâse',
'grata',
'grava',
'greni',
'grépa',
'grifa',
'grijé',
'grile',
'grilè',
'gripa',
'griva',
'griwé',
'gróbó',
'groma',
'gróou',
'gwâle',
'gwije',
'gyela',
'gyele',
'gyêra',
'gyéta',
'idran',
'inbra',
'infan',
'infya',
'insya',
'intéi',
'intsó',
'invwa',
'istré',
'jaméi',
'janpé',
'janpi',
'jaozi',
'jésté',
'jestó',
'jifla',
'jostó',
'joupa',
'joyou',
'kyeën',
'kyele',
'kyèle',
'kyepi',
'kyeri',
'kyesa',
'lâche',
'lache',
'lapën',
'liron',
'lizyè',
'lónye',
'lóton',
'maadi',
'maadó',
'màche',
'mâcló',
'mâcwè',
'mâfya',
'malon',
'mâmōo',
'manca',
'manda',
'manéé',
'manpa',
'manta',
'manti',
'mapâa',
'mâpri',
'marca',
'mârca',
'maron',
'marya',
'masca',
'matën',
'mâtin',
'matsó',
'mâvra',
'mawan',
'mawën',
'mâyou',
'mazîe',
'mécha',
'meche',
'mécla',
'mécló',
'médze',
'mégró',
'melâa',
'melon',
'mënma',
'mepri',
'mêrda',
'mergó',
'mèrla',
'métra',
'métre',
'métré',
'métró',
'metse',
'mewën',
'mijon',
'mijōo',
'minéi',
'minon',
'minōo',
'minsó',
'minta',
'mitin',
'mobla',
'mobló',
'moche',
'módze',
'mojou',
'móman',
'mómón',
'mòrga',
'mòrta',
'môrta',
'morti',
'mosca',
'mótéi',
'motën',
'mótra',
'motse',
'mótsé',
'motsó',
'mouwa',
'mowéi',
'mowën',
'mowin',
'mwénó',
'mwire',
'mwitó',
'myówa',
'nadze',
'naeta',
'nafla',
'nâréi',
'néawe',
'nenën',
'nétée',
'nijye',
'nirâa',
'nójwe',
'noole',
'norën',
'noura',
'nowéi',
'nyare',
'nyese',
'nyire',
'nyóca',
'nyócó',
'nyona',
'nyówa',
'obêje',
'ochya',
'óchya',
'ocopa',
'ódjya',
'ódjye',
'omele',
'onati',
'onbra',
'ondze',
'ondzé',
'onecó',
'onéta',
'ongan',
'onlâa',
'ónóra',
'ontou',
'onyon',
'óónye',
'óoula',
'óoule',
'óouló',
'óoura',
'óouta',
'óouwa',
'óouwe',
'ópèra',
'ópója',
'ordzò',
'orele',
'orena',
'òrgwé',
'ōrgwé',
'ôrgyé',
'orlâe',
'oscōo',
'ostîa',
'ótava',
'otele',
'ótèlè',
'oubën',
'oubla',
'oubli',
'ouncó',
'ouron',
'outon',
'outré',
'ouvêe',
'óvawó',
'owiva',
'pacha',
'pâcha',
'paché',
'pâdze',
'paeou',
'pâkye',
'pakyé',
'panté',
'panye',
'parco',
'paréé',
'parié',
'parin',
'parla',
'parlé',
'patën',
'paton',
'patse',
'patsó',
'patwé',
'pavya',
'pawâe',
'pawën',
'pebló',
'pêcha',
'pêche',
'pêché',
'pechó',
'péclé',
'pécló',
'pedou',
'pédre',
'pedri',
'péiné',
'péinó',
'péire',
'péiwa',
'péjan',
'péjéi',
'pekye',
'pekyé',
'peléi',
'penéi',
'pëngi',
'pënta',
'pënte',
'penye',
'penyó',
'peóta',
'peòta',
'peowa',
'peowe',
'pêrda',
'perou',
'pèrtó',
'pesta',
'pétâa',
'pétâé',
'petéi',
'pétéi',
'petró',
'petse',
'pétse',
'pewáa',
'pewën',
'piche',
'pidze',
'pijon',
'pinna',
'pinse',
'pinsó',
'pinta',
'pioné',
'pióta',
'piton',
'pivra',
'pivró',
'placa',
'plané',
'plânó',
'plate',
'pleji',
'plojo',
'ploma',
'pobló',
'pócra',
'pofaé',
'pólin',
'ponpa',
'ponta',
'ponté',
'ponya',
'popla',
'popló',
'porca',
'porga',
'pòrpa',
'pòrpé',
'porta',
'pòrta',
'porti',
'póson',
'pósta',
'potan',
'pouja',
'pousa',
'pouta',
'préfé',
'préta',
'prija',
'priōo',
'priou',
'prire',
'priwé',
'promi',
'prósé',
'prówa',
'pwéea',
'pwire',
'pyese',
'pyoca',
'racâa',
'râche',
'racla',
'râcló',
'racró',
'radze',
'râeon',
'rafla',
'rafya',
'ramâe',
'ranbo',
'ranma',
'ranpa',
'ransó',
'rapën',
'rapon',
'rapôo',
'ratéi',
'raton',
'râtse',
'râtsó',
'rècha',
'rêcha',
'rechi',
'redii',
'redui',
'redze',
'rédze',
'rééla',
'reele',
'réélé',
'rèélé',
'régla',
'regōo',
'réita',
'rejën',
'rémwa',
'rënga',
'rënma',
'repli',
'resca',
'réspé',
'rèsté',
'retsó',
'réwéi',
'rewia',
'riban',
'ridzó',
'rijin',
'rijon',
'ripâe',
'risin',
'rison',
'rlwin',
'rocan',
'rócha',
'róché',
'ródze',
'ródzé',
'ródzó',
'rójéi',
'ronca',
'ronda',
'rondò',
'ronye',
'ropyó',
'rósâe',
'rotse',
'roudó',
'roule',
'rouló',
'roupa',
'rousa',
'rouwa',
'rowéi',
'rwédó',
'rwena',
'rwidó',
'ryéba',
'ryeca',
'saete',
'sanló',
'sanpe',
'saowa',
'sebōo',
'secon',
'sepre',
'sêrté',
'seryé',
'sibōo',
'siéta',
'sigâa',
'siman',
'sinla',
'sinle',
'sinlo',
'sinye',
'sinyé',
'sinyó',
'sócâé',
'sonda',
'sowën',
'steca',
'stéca',
'stecó',
'swate',
'tabéé',
'tabla',
'tâbla',
'tabló',
'tâbló',
'tâcha',
'tacha',
'tacon',
'talin',
'talōo',
'tâmin',
'tanbo',
'tandi',
'tanéa',
'tanōo',
'tanpa',
'tanpi',
'tantó',
'taona',
'tapou',
'tardé',
'tardi',
'tarpa',
'târpa',
'tatse',
'tâtsó',
'tavwa',
'tawan',
'tchyé',
'tchyè',
'tebâe',
'techó',
'téita',
'temon',
'tëncó',
'ténéa',
'tënté',
'teran',
'terdó',
'tèrgó',
'terin',
'tèrin',
'tērla',
'terle',
'tèrmè',
'têrmó',
'têrna',
'terya',
'terye',
'testa',
'tétâa',
'tetou',
'tetse',
'tevâe',
'tezîe',
'tigre',
'tijye',
'tinte',
'tirōo',
'titre',
'tócâe',
'toche',
'todri',
'tókyé',
'tónâe',
'tonba',
'tonna',
'tópló',
'tópon',
'torbé',
'torco',
'torcó',
'tórin',
'tòrna',
'tòrné',
'torni',
'tōrta',
'tôrtò',
'tósin',
'tóson',
'traca',
'traça',
'trafè',
'trafi',
'trâle',
'trapa',
'trapó',
'trata',
'trati',
'trecó',
'trèêe',
'tréga',
'trepé',
'trepi',
'tréta',
'trétó',
'troca',
'tróca',
'trole',
'trólé',
'tróne',
'trópa',
'tróse',
'tróta',
'tsacrou',
'tsâda',
'tsamò',
'tsana',
'tsani',
'tsaōo',
'tsara',
'tsaré',
'tsarfi',
'tsase',
'tsàse',
'tsâsé',
'tsàta',
'tsàte',
'tsati',
'tsave',
'tsawé',
'tsawi',
'tsebó',
'tséja',
'tsena',
'tsêre',
'tsêré',
'tsoca',
'tsocó',
'tsóou',
'tsowa',
'tsówé',
'vaeon',
'vaéta',
'vagon',
'valin',
'vanae',
'vanōo',
'vaópa',
'vapōo',
'vârin',
'vawōo',
'vêcha',
'vêche',
'vejën',
'venye',
'vêrda',
'véréi',
'verën',
'verin',
'vêrna',
'verni',
'verte',
'verya',
'verye',
'vesta',
'vyèje',
'vinse',
'vioné',
'vipêe',
'visye',
'vitéé',
'vitre',
'vitri',
'vivin',
'vòrta',
'vwari',
'vwata',
'vwéea',
'vwepi',
'vwéró',
'vwesa',
'vwese',
'vwésó',
'vwete',
'vwida',
'vwidó',
'vyele',
'vyeró',
'vyôon',
'vyówé',
'wacôo',
'wafra',
'wâfra',
'wakye',
'wanda',
'wanpa',
'wanse',
'wanya',
'wanye',
'waona',
'waoun',
'wârje',
'waséi',
'watën',
'wâtse',
'wâtsi',
'weeon',
'wééta',
'wefra',
'wèkye',
'wënma',
'wenwé',
'wenya',
'wenye',
'wepra',
'weson',
'wéstó',
'wétra',
'wetse',
'wevré',
'wevyè',
'wibró',
'wijyé',
'winga',
'witre',
'wivra',
'wivró',
'youwa',
'zoupa',
]

if (CONFIG.normalization) {
  VALIDGUESSES.forEach(
    (val, i) => (VALIDGUESSES[i] = val.normalize(CONFIG.normalization))
  )
}
